<!--
    校区管理-员工管理-支付页面
    功能：年服务支付页面
    说明：版本3.0需求
-->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="第三方支付窗口"
      width="650px"
      append-to-body
    >
      <div class="content">
        <div
          class="item-row"
          style="padding-top:20px"><span class="title">年服务优惠价：</span><span class="pice">￥99999</span></div>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="submitData()">完成支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'SetAnnualFee',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      dateVal: null,
      isSuccess: false,
    };
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    submitData() {
    },
  },
};
</script>
<style lang="scss" scoped>
.content{
  padding: 0 10px;
}
.item-row{
  padding-top: 15px;
}
.pice{
  font-size: 20px;
    color: red;
}
.dialog-footer{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Staff/components/openPlay.vue